import { render, staticRenderFns } from "./monthlyPayManager.vue?vue&type=template&id=0881185d&scoped=true"
import script from "./monthlyPayManager.vue?vue&type=script&lang=js"
export * from "./monthlyPayManager.vue?vue&type=script&lang=js"
import style0 from "./monthlyPayManager.vue?vue&type=style&index=0&id=0881185d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881185d",
  null
  
)

export default component.exports